import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, Search } from "lucide-react";
import { useCart } from "../context/CartContext";
import { BRAND } from "../lib/api";

const links = [
  { to: "/", label: "Acasă" },
  { to: "/carti", label: "Cărți" },
  { to: "/colectii", label: "Colecții" },
  { to: "/jurnal", label: "Jurnal" },
  { to: "/despre", label: "Despre Vis de Zi" },
  { to: "/galerie", label: "Galerie" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { count, setDrawerOpen } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md" style={{ background: "rgba(249,246,240,0.88)", borderBottom: "1px solid var(--vdz-cream-border)" }} data-testid="site-header">
      <div className="container-vdz flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-logo">
          <span className="font-serif-display text-2xl md:text-3xl tracking-tight" style={{ color: "var(--vdz-navy)" }}>
            VIS <span className="gold-text">DE</span> ZI
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `font-serif-accent text-[0.78rem] tracking-[0.22em] uppercase transition-colors ${
                  isActive ? "text-[color:var(--vdz-gold)]" : "text-[color:var(--vdz-navy)] hover:text-[color:var(--vdz-gold)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setDrawerOpen(true)}
            className="relative p-2 hover:text-[color:var(--vdz-gold)] transition-colors"
            style={{ color: "var(--vdz-navy)" }}
            data-testid="nav-cart-button"
            aria-label="Coș"
          >
            <ShoppingBag size={22} strokeWidth={1.4} />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-1 min-w-[18px] h-[18px] rounded-full text-[10px] flex items-center justify-center font-semibold"
                    style={{ background: "var(--vdz-gold)", color: "var(--vdz-navy)" }}
                    data-testid="cart-count-badge">
                {count}
              </span>
            )}
          </button>
          <button
            className="lg:hidden p-2"
            onClick={() => setOpen((o) => !o)}
            style={{ color: "var(--vdz-navy)" }}
            data-testid="nav-mobile-toggle"
            aria-label="Meniu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t" style={{ borderColor: "var(--vdz-cream-border)" }}>
          <div className="container-vdz py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `font-serif-accent text-sm tracking-[0.2em] uppercase py-2 ${
                    isActive ? "text-[color:var(--vdz-gold)]" : "text-[color:var(--vdz-navy)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
